<div class="relative inline-flex" [ngClass]="size">
  <div class="cursor-pointer transition hover:brightness-105 relative"
    [appTextTooltip]="showCommentInTooltip ? comment : ''"
    [tooltipOffset]="20"
    [tooltipBackground]="tooltipTheme.fond"
    [tooltipTextColor]="tooltipTheme.texte"
    [tooltipBorder]="tooltipTheme.bordure">

    <!-- MODE BULLE -->
    <ng-container *ngIf="showAsBubble; else smileyMode">
      <ng-container [ngSwitch]="emotionType">
        <!-- Bulle contente (score 1) -->
        <svg *ngSwitchCase="'content'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="bulleGradVert" x1="10%" y1="0%" x2="90%" y2="100%">
              <stop offset="0%" stop-color="#A7F3D0" />
              <stop offset="45%" stop-color="#4ADE80" />
              <stop offset="100%" stop-color="#16A34A" />
            </linearGradient>
            <radialGradient id="bulleShineVert" cx="30%" cy="25%" r="60%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.65" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
            <clipPath id="bulleClipVert">
              <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z" />
            </clipPath>
          </defs>
          <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z"
            fill="url(#bulleGradVert)" stroke="#166534" stroke-width="2.2" stroke-linejoin="round" />
          <circle cx="38" cy="30" r="28" fill="url(#bulleShineVert)" clip-path="url(#bulleClipVert)" />
          <circle cx="38" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="62" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="37" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <circle cx="61" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <path d="M 40,55 Q 50,66 60,55" fill="none" stroke="#064E3B" stroke-width="2.2" stroke-linecap="round" />
        </svg>

        <!-- Bulle indifférente (score 2) -->
        <svg *ngSwitchCase="'indifferent'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="bulleGradOrange" x1="10%" y1="0%" x2="90%" y2="100%">
              <stop offset="0%" stop-color="#FED7AA" />
              <stop offset="50%" stop-color="#F97316" />
              <stop offset="100%" stop-color="#EA580C" />
            </linearGradient>
            <radialGradient id="bulleShineOrange" cx="30%" cy="25%" r="60%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.6" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
            <clipPath id="bulleClipOrange">
              <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z" />
            </clipPath>
          </defs>
          <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z"
            fill="url(#bulleGradOrange)" stroke="#9A3412" stroke-width="2.2" stroke-linejoin="round" />
          <circle cx="38" cy="30" r="28" fill="url(#bulleShineOrange)" clip-path="url(#bulleClipOrange)" />
          <circle cx="38" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="62" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="37" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <circle cx="61" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <line x1="44" y1="57" x2="56" y2="57" stroke="#431407" stroke-width="2.5" stroke-linecap="round" />
        </svg>

        <!-- Bulle mécontente (score 3) -->
        <svg *ngSwitchCase="'mecontent'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="bulleGradRouge" x1="10%" y1="0%" x2="90%" y2="100%">
              <stop offset="0%" stop-color="#FECACA" />
              <stop offset="45%" stop-color="#F87171" />
              <stop offset="100%" stop-color="#DC2626" />
            </linearGradient>
            <radialGradient id="bulleShineRouge" cx="30%" cy="25%" r="60%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.55" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
            <clipPath id="bulleClipRouge">
              <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z" />
            </clipPath>
          </defs>
          <path d="M 50,23 A 32,22 0 0 1 82,45 A 32,22 0 0 1 50,67 A 32,22 0 0 1 35,65 L 23,74 L 27,60 A 32,22 0 0 1 18,45 A 32,22 0 0 1 50,23 Z"
            fill="url(#bulleGradRouge)" stroke="#991B1B" stroke-width="2.2" stroke-linejoin="round" />
          <circle cx="38" cy="30" r="28" fill="url(#bulleShineRouge)" clip-path="url(#bulleClipRouge)" />
          <circle cx="38" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="62" cy="42" r="3.5" fill="#1C1917" />
          <circle cx="37" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <circle cx="61" cy="40.5" r="1.3" fill="#FFFFFF" opacity="0.95" />
          <line x1="33" y1="35" x2="43" y2="38" stroke="#7F1D1D" stroke-width="2.2" stroke-linecap="round" />
          <line x1="67" y1="35" x2="57" y2="38" stroke="#7F1D1D" stroke-width="2.2" stroke-linecap="round" />
          <path d="M 44,59 Q 50,52 56,59" fill="none" stroke="#7F1D1D" stroke-width="2.2" stroke-linecap="round" />
        </svg>
      </ng-container>
    </ng-container>

    <!-- MODE SMILEY -->
    <ng-template #smileyMode>
      <ng-container [ngSwitch]="emotionType">
        <svg *ngSwitchCase="'content'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gradVertSmiley" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#4ADE80" />
              <stop offset="100%" stop-color="#22C55E" />
            </linearGradient>
            <radialGradient id="shineSmileyVert" cx="35%" cy="30%" r="55%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.6" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
          </defs>
          <circle cx="50" cy="50" r="46" fill="url(#gradVertSmiley)" stroke="#166534" stroke-width="2.2" />
          <circle cx="50" cy="50" r="46" fill="url(#shineSmileyVert)" />
          <circle cx="34" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="66" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="32.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <circle cx="64.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <path d="M 30,62 C 38,82 62,82 70,62" fill="none" stroke="#14532D" stroke-width="3.2" stroke-linecap="round" />
        </svg>

        <svg *ngSwitchCase="'indifferent'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gradOrangeSmiley" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#FBA834" />
              <stop offset="100%" stop-color="#F97316" />
            </linearGradient>
            <radialGradient id="shineOrangeSmiley" cx="35%" cy="30%" r="55%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.55" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
          </defs>
          <circle cx="50" cy="50" r="46" fill="url(#gradOrangeSmiley)" stroke="#7C2D12" stroke-width="2.2" />
          <circle cx="50" cy="50" r="46" fill="url(#shineOrangeSmiley)" />
          <circle cx="34" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="66" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="32.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <circle cx="64.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <path d="M 34,67 L 66,67" fill="none" stroke="#431407" stroke-width="3.8" stroke-linecap="round" />
        </svg>

        <svg *ngSwitchCase="'mecontent'" class="relative top-2"
          width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gradRougeSmiley" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#F87171" />
              <stop offset="100%" stop-color="#DC2626" />
            </linearGradient>
            <radialGradient id="shineRougeSmiley" cx="35%" cy="30%" r="55%">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.5" />
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
            </radialGradient>
          </defs>
          <circle cx="50" cy="50" r="46" fill="url(#gradRougeSmiley)" stroke="#7F1D1D" stroke-width="2.2" />
          <circle cx="50" cy="50" r="46" fill="url(#shineRougeSmiley)" />
          <circle cx="34" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="66" cy="41" r="5.2" fill="#1C1917" />
          <circle cx="32.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <circle cx="64.5" cy="38.8" r="1.8" fill="#FFFFFF" opacity="0.95" />
          <path d="M 30,71 C 38,53 62,53 70,71" fill="none" stroke="#450A0A" stroke-width="3.5" stroke-linecap="round" />
        </svg>
      </ng-container>
    </ng-template>
  </div>

  <!-- Coche de sélection : position personnalisée  -->
  <div *ngIf="showAsSelected" class="absolute -top-[18%] -right-[10%] rounded-full p-0 px-0 border-0 border-green-500 z-10">
    <i class="fa-solid fa-check text-green-500  text-[1.9em] leading-none" style="text-shadow:-1px -1px 0 #fff,1px -1px 0 #fff,-1px  1px 0 #fff,1px  1px 0 #fff;"></i>
  </div>
</div>